import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { MenuItem } from 'primeng/primeng';
import { AppComponent } from './app.component';
import { UserModel } from './shared/model/user.model';
import { MenuModel } from './shared/model/menu.model';
import { UserService } from './shared/service/user.service';
import { MenuService } from './shared/service/menu.service';

@Component({
    selector: 'app-menu',
    template: `
        <ul app-submenu [item]="model" root="true" [reset]="reset" 
        class="ultima-menu ultima-main-menu clearfix"
        visible="true"></ul>
    `
})
export class AppMenuComponent implements OnInit {

    @Input() reset: boolean;

    model: any[];

    constructor(
        public app: AppComponent,
        private menuService: MenuService,
        private userService: UserService,
        private translateService: TranslateService,
    ) {}

    ngOnInit() {
        this.model = [];

        if(localStorage.getItem('loginToken')){
            this.userService.getByToken(localStorage.getItem('loginToken')).subscribe((user: UserModel) => {

                this.translateService.get('translate_version').subscribe(() => {

                    this.menuService.getPaginated(0, 1000).subscribe((result) => {

                        result.rows.forEach((item: MenuModel) => {

                            if(user.user_type.menu_ids && user.user_type.menu_ids.indexOf(item.id) > -1) {
                                this.model.push({
                                    label: this.translateService.instant(item.translate || item.name),

                                    icon: item.icon,
                                    ...(item.children_menus.length > 0 ? {items: []} : {}),
                                    ...(item.router_link ? {routerLink: [`${item.router_link}`]} : {})
                                });

                                item.children_menus.forEach((subItem: MenuModel) => {

                                    if(user.user_type.menu_ids.indexOf(subItem.id) > -1){
                                        this.model[this.model.length - 1].items.push({
                                            label: this.translateService.instant(subItem.translate || subItem.name),

                                            icon: subItem.icon,
                                            routerLink: [`${subItem.router_link}`]
                                        });
                                    }

                                });
                            }

                        });

                        // Injeta itens de Tabela de Medidas e Produtos na aba Cadastros (temporário — mover para banco após validação)
                        const measureTableItem = {
                            label: this.translateService.instant('measure_table'),
                            icon: 'straighten',
                            routerLink: ['/measure-table']
                        };
                        const productItem = {
                            label: this.translateService.instant('products'),
                            icon: 'inventory_2',
                            routerLink: ['/product']
                        };
                        const cadastros = this.model.find(m =>
                            m.label && (
                                m.label.toLowerCase().includes('cadastro') ||
                                m.label.toLowerCase().includes('registration')
                            )
                        );
                        if (cadastros && cadastros.items) {
                            cadastros.items.push(measureTableItem);
                            cadastros.items.push(productItem);
                        } else {
                            this.model.push(measureTableItem);
                            this.model.push(productItem);
                        }

                    });

                })
            });
        }
    }

    changeTheme(theme) {
        let themeLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById('theme-css');
        let layoutLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById('layout-css');

        themeLink.href = 'assets/theme/theme-' + theme + '.css';
        layoutLink.href = 'assets/layout/css/layout-' + theme + '.css';
    }
}

@Component({
    selector: '[app-submenu]',
    template: `
        <ng-template ngFor let-child let-i="index" [ngForOf]="(root ? item : item.items)">
            <li [ngClass]="{'active-menuitem': isActive(i)}" [class]="child.badgeStyleClass"
                *ngIf="child.visible === false ? false : true">
                <a [href]="child.url||'#'" (click)="itemClick($event,child,i)" (mouseenter)="onMouseEnter(i)"
                   class="ripplelink" *ngIf="!child.routerLink"
                   [attr.tabindex]="!visible ? '-1' : null" [attr.target]="child.target">
                    <i class="material-icons">{{child.icon}}</i>
                    <span>{{child.label}}</span>
                    <span class="menuitem-badge" *ngIf="child.badge">{{child.badge}}</span>
                    <i class="material-icons submenu-icon" *ngIf="child.items">keyboard_arrow_down</i>
                </a>

                <a (click)="itemClick($event,child,i)" (mouseenter)="onMouseEnter(i)" class="ripplelink"
                   *ngIf="child.routerLink"
                   [routerLink]="child.routerLink" routerLinkActive="active-menuitem-routerlink"
                   [routerLinkActiveOptions]="{exact: true}" [attr.tabindex]="!visible ? '-1' : null"
                   [attr.target]="child.target">
                    <i class="material-icons">{{child.icon}}</i>
                    <span>{{child.label}}</span>
                    <span class="menuitem-badge" *ngIf="child.badge">{{child.badge}}</span>
                    <i class="material-icons submenu-icon" *ngIf="child.items">keyboard_arrow_down</i>
                </a>
                <div class="layout-menu-tooltip">
                    <div class="layout-menu-tooltip-arrow"></div>
                    <div class="layout-menu-tooltip-text">{{child.label}}</div>
                </div>
                <ul app-submenu [item]="child" *ngIf="child.items" [visible]="isActive(i)" [reset]="reset"
                    [@children]="(app.isSlim()||app.isHorizontal())&&root ? isActive(i) ? 'visible' : 'hidden' : isActive(i) ? 'visibleAnimated' : 'hiddenAnimated'"></ul>
            </li>
        </ng-template>
    `,
    animations: [
        trigger('children', [
            state('hiddenAnimated', style({
                height: '0px'
            })),
            state('visibleAnimated', style({
                height: '*'
            })),
            state('visible', style({
                height: '*'
            })),
            state('hidden', style({
                height: '0px'
            })),
            transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ]
})
export class AppSubMenu {

    @Input() item: MenuItem;

    @Input() root: boolean;

    @Input() visible: boolean;

    _reset: boolean;

    activeIndex: number;

    constructor(public app: AppComponent) {
    }

    itemClick(event: Event, item: MenuItem, index: number) {
        if (this.root) {
            this.app.menuHoverActive = !this.app.menuHoverActive;
        }

        // avoid processing disabled items
        if (item.disabled) {
            event.preventDefault();
            return true;
        }

        // activate current item and deactivate active sibling if any
        this.activeIndex = (this.activeIndex === index) ? null : index;

        // execute command
        if (item.command) {
            item.command({ originalEvent: event, item: item });
        }

        // prevent hash change
        if (item.items || (!item.url && !item.routerLink)) {
            event.preventDefault();
        }

        // hide menu
        if (!item.items) {
            if (this.app.isHorizontal() || this.app.isSlim())
                this.app.resetMenu = true;
            else
                this.app.resetMenu = false;

            this.app.overlayMenuActive = false;
            this.app.staticMenuMobileActive = false;
            this.app.menuHoverActive = !this.app.menuHoverActive;
        }
    }

    onMouseEnter(index: number) {
        if (this.root && this.app.menuHoverActive && (this.app.isHorizontal() || this.app.isSlim())) {
            this.activeIndex = index;
        }
    }

    isActive(index: number): boolean {
        return this.activeIndex === index;
    }

    @Input()
    get reset(): boolean {
        return this._reset;
    }

    set reset(val: boolean) {
        this._reset = val;

        if (this._reset && (this.app.isHorizontal() || this.app.isSlim())) {
            this.activeIndex = null;
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/app.menu.component.ts